import { Component, Input, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { WindowService } from "@merri/common";
import { BehaviorSubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { VariantSkuFavoritesList, VisionboardItem } from "../../../models";
import { ForceVisionboardItemAddRemoveButton } from "../visionboard-item-add-remove-button/visionboard-item-add-remove-button.component";

@Component({
    selector: "app-visionboard-item-controls-container",
    templateUrl: "./visionboard-item-controls-container.component.html",
    styleUrls: ["./visionboard-item-controls-container.component.scss"],
    standalone: false
})
export class VisionboardItemControlsContainerComponent implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject();

  @Input() item: VisionboardItem;
  @Input() isHovered: boolean;
  @Input() forceVisionboardItemAddRemoveButton: ForceVisionboardItemAddRemoveButton;
  @Input() favoritesList: VariantSkuFavoritesList;
  @Input() showMoreActionsMenu: boolean = true;
  @Input() source: string;
  @Input() customMoreActionsTemplate: TemplateRef<void>;
  @Input() customAddRemoveTemplate: TemplateRef<void>;

  isMenuOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  mobileMode: boolean;

  constructor(private _windowService: WindowService) {}

  ngOnInit(): void {
    this._windowService
      .observeMax$(539)
      .pipe(takeUntil(this._destroyed$))
      .subscribe({
        next: m => {
          this.mobileMode = m.matches;
        },
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
